import { render } from "./Billing.vue?vue&type=template&id=2f1d6770&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=2f1d6770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1d6770"]])

export default __exports__